var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-alert",
            {
              attrs: {
                dense: "",
                dark: "",
                color: "primary"
              },
              scopedSlots: _vm._u([
                {
                  key: "prepend",
                  fn: function fn() {
                    return [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            size: "28",
                            color: "white"
                          }
                        },
                        [_vm._v("mdi-information-outline")]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(
                " Parked domains make your website available from another domain name. For example, you can make www.example.net and www.example.org show content from www.example.com. "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Add New Parked Domain ")]),
              _c(
                "gg-card-text",
                [
                  _c("add-alias-form", {
                    on: {
                      "domain-created": _vm.reloadTable
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("aliases-table", {
            attrs: {
              "table-should-be-reloaded": _vm.tableShouldBeReloaded
            },
            on: {
              "table-reloaded": _vm.tableReloaded
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }